export default __webpack_public_path__ + "menu-discounts-icon.0169c20e97a40f33aa04c83aa25b68ac.svg";